export default __webpack_public_path__ + "static/media/Martin.24327c75.png";